/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { useModal } from "hooks";
// import { fabric } from "fabric";
import * as fabric from 'fabric'; 
import { PAGE_TYPES } from "config";
import { ToastContainer, toast } from 'react-toastify';
import {
  getImage,
  rejectPage,
  getNextPageCrop,
  postPageAutoCrop,
  savePageIncentiveString,
  saveCircularIncentiveString,
  getCircularById,
  deleteAdBlockById,
  deleteSectionById,
  unsetDoubletruckPage,
  createDoubletruckPage,
  deleteDuplicatePageAdBlocks,
  getCurrentUserAPI,
  getPageById,
  createDoubletruckPageVerical,
  getPageCrops,
  approvePage,
  getPageByObjId,
  getCircularByObjID
} from "api";
import useKeypress from "react-use-keypress";
import styled from "styled-components";
// import "cropperjs/dist/cropper.css";
import { MainLayout } from "layouts";
// import { useAuthContext } from "contexts";
import { useMainContext, useAdblockHistoryContext } from "contexts";
import {
  Button,
  Alert,
  Link,
  ColorPick,
  AdblockToolButton,
  HistoryDropdown,
  AdblockIncentives,
  SectionItem,
  AdblockItem,
  GroupItem,
  DropDownMenu,
  DigitalCouponCheck,
  FillSelect
} from "components";
import { RetryCroppingModal, RejectPageWarning, ApprovePageNoAdblockWarning } from "modals";
import { ConfirmationModal } from "modals/commons/ConfirmationModal";
import { splitIncentives, setCachedImage, getCachedImage } from "utils";
import { useParams, useLocation } from "@reach/router";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { format } from "date-fns";
import { MdRefresh } from "react-icons/md";
import { FaHourglass, FaTrash } from "react-icons/fa";
import { VscSplitHorizontal, VscSplitVertical } from "react-icons/vsc";

const OUTLINE_COLORS = ["blue", "red", "yellow"];

export const AdBlocksPage = () => {
  const params = useParams();
  const blockRef = useRef();
  const location = useLocation();
  // const { userInfo } = useAuthContext();

  const {
    currentPageId,
    currentCircularId,
    setCurrentCircularId,
    setCurrentPageId,
    setCurrentPage,
    setPreviousTime,
    postPageEvents,
    setSessionId,
    currentAdBlockId,
    setLiveCounterData,
    setActiveRetailer
  } = useMainContext();

  const [copiedText, setCopiedText] = useState(false);
  const { initHistory, pushHistory } = useAdblockHistoryContext();

  //Loading States
  const [isLoading, setIsLoading] = useState(true);
  const [isAdCropping, setIsAdCropping] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  //const [isRejected, setIsRejected] = useState(false);

  //Page data
  const [pageData, setPageData] = useState([]);
  const [pageType, setpageType] = useState("");
  const [isDoubleTruck, setIsDoubleTruck] = useState(false);
  const [parentPageData, setparentPageData] = useState([]);
  const [parentPageCircularData, setparentPageCircularData] = useState([]);

  //Adblock data
  const [adBlockData, setAdBlockData] = useState([]);
  const [isNoQueue, setNoQueue] = useState(false);
  const [queueCount, setQueueCount] = useState("");
  const [messageID, setMessageID] = useState("");
  const [blockType, setBlockType] = useState("adblock");
  const [isApproveDisabled, setIsApproveDisabled] = useState(false);

  // Canvas information
  const [canvas, setCanvas] = useState("");
  const [canvasRatio, setCanvasRatio] = useState(1);
  const [canvasObjects, setCanvasObjects] = useState([]);
  const [activeCanvasObject, setActiveCanvasObject] = useState(null);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  
  const [showAdBlocks, setShowAdBlocks] = useState(true);
  const [showGroups, setShowGroups] = useState(true);
  const [showSections, setShowSections] = useState(true);

  // Error Messages
  const [errorText, setErrorText] = useState("");
  const [canvasErrorMessage, setCanvasErrorMessage] = useState("");

  //Modals and user information
  const alertModal = useModal();
  const rejectPageModal = useModal();
  const approvePageWithNoAdblockModal = useModal();
  const retryCroppingModal = useModal();

  // View info
  const [currentAdblockId, setCurrentAdblockId] = useState("");
  const [selectedIndex, setSelectedIndex] = useState("");
  const [circularName, setCircularName] = useState("");
  const [currentOutlineColor, setCurrentOutlineColor] = useState(
    OUTLINE_COLORS[0]
  );
  const [currentCanvasObjects, setCurrentCanvasObjects] = useState([]);
  const [fillActive, setFillActive] = useState(true);

  // Digital Coupon flag
  const [digitalCouponApplied, setDigitalCouponApplied] = useState(false);

  var started = false;
  var x = 0;
  var y = 0;
  // The crop rect currently being drawn (created lazily on drag, see mouse:move).
  var creatingRect = null;
  // Minimum drag distance (px, both axes) before a right-click drag creates a crop.
  // Bare right-clicks (no drag) must never create a block, otherwise dummy
  // crops inflate the user's cropping counter even though override/dupe
  // checks remove them after approval.
  const MIN_CROP_DRAG_SIZE = 5;


  // Incentive data
  const [incentiveData, setIncentiveData] = useState([]);
  const handleAddIncentive = (newData) => {
    let allItems = [...incentiveData];
    for(var i = 0; i < newData.length; i++) {
      allItems = [ ...allItems, { type: newData[i].attach_to.toString().toLowerCase(), text: newData[i].incentive_text } ];
    }
    setIncentiveData(allItems);
  };
  const handleRemoveIncentive = (index) => {
    let temp = [...incentiveData];
    temp.splice(index, 1);
    setIncentiveData(temp);
  };
  const handleUpdateIncentive = (index, data) => {
    let temp = [...incentiveData];
    temp.splice(index, 1, data);
    setIncentiveData(temp);
  };

  // Section Data
  const handleSectionSelect = async (uuid, index) => {
    if (index < canvas.getObjects().length) {
      setCurrentAdblockId(uuid);
      canvas.setActiveObject(canvas.item(index));
      canvas.requestRenderAll();
      setSelectedIndex(index);
      await postPageEvents("click", `Section ${index}`);
    }
  };

  /*
  ///////////////////////////////////////
  ////// Start Methods //////////////////
  /////////////////////////////////////
  */

  const sortBy = ['group','section','adblock']
  const customSort = ({data, sortBy, sortField}) => {
    const sortByObject = sortBy.reduce((obj, item, index) => {
      return {
        ...obj,
        [item]: index
      }
    }, {})
    return data.sort((a, b) => sortByObject[a[sortField]] - sortByObject[b[sortField]]);
  }
  
  //const sortAdblocks = (a,b)=> (b.rejected - a.rejected);

  const init = async (blockType, canvas) => {
    // display dotted boundary when over rect
    canvas.on("mouse:over", function (e) {
      handleCanvisObjectMouseOver(canvas, e);
    });

    // remove dotted boundary when over rect
    canvas.on("mouse:out", function (e) {
      if (e?.target) {
        e.target.set("strokeDashArray", null);

        if (canvas.status === "crop") {
          e.target.hoverCursor = "crosshair";
        } else {
          e.target.hoverCursor = "default";
        }

        canvas.renderAll();
      }
    });
    // zoom when mouse wheel
    canvas.on("mouse:wheel", function (opt) {
      var delta = opt.e.deltaY;
      var zoom = canvas.getZoom();
      zoom *= 0.999 ** delta;
      if (zoom > 20) zoom = 20;
      if (zoom < 0.01) zoom = 0.01;
      canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
      var vpt = this.viewportTransform;
      if (canvas.getHeight() > blockRef.current.offsetHeight) {
        vpt[4] = 200 - (1000 * zoom) / 2;
        vpt[5] = 200 - (1000 * zoom) / 2;
      }
    });
    // pan when alt key & mouse down
    canvas.off('mouse:down')
    canvas.on("mouse:down", function (opt) {
      const evt = opt.e;
      if (evt.altKey === true) {
        this.isDragging = true;
        this.selection = false;
        this.lastPosX = evt.clientX;
        this.lastPosY = evt.clientY;
      } else if (evt.button === 2) {
        var mouse = canvas.getPointer(evt);
        started = true;
        x = mouse.x;
        y = mouse.y;
        this.isCreating = true;
        // NOTE: the crop rect is intentionally NOT created here. It is
        // created lazily in mouse:move once the user actually drags past
        // MIN_CROP_DRAG_SIZE, so a bare right-click never adds a block.
      }
    });

    canvas.on("mouse:move", function (opt) {
      if (this.isDragging) {
        var e = opt.e;
        var vpt = this.viewportTransform;
        vpt[4] += e.clientX - this.lastPosX;
        vpt[5] += e.clientY - this.lastPosY;
        this.requestRenderAll();
        this.lastPosX = e.clientX;
        this.lastPosY = e.clientY;
      } else if (this.isCreating) {
        // Resize the newly created crop while mouse draging
        if (!started) {
          return false;
        }

        let mouse = canvas.getPointer(opt.e);

        let w = mouse.x - x,
          h = mouse.y - y;

        if (!w || !h) {
          return false;
        }

        // Create the crop only after a real drag past the threshold, so
        // repeated bare right-clicks cannot create blocks and skew the
        // cropping counter.
        if (!creatingRect) {
          if (Math.abs(w) < MIN_CROP_DRAG_SIZE || Math.abs(h) < MIN_CROP_DRAG_SIZE) {
            return false;
          }
          var today = new Date();
          creatingRect = new fabric.Rect({
            width: 0,
            height: 0,
            left: x,
            top: y,
            stroke: currentOutlineColor,
            strokeWidth: 1,
            fill: blockType === "adblock" ? "transparent" : "#3BC7E320",
            cornerColor: "white",
            cornerStrokeColor: currentOutlineColor,
            id: "temp-" + today.getTime(),
            blockType,
          });
          creatingRect.setControlsVisibility({ mtr: false });
          canvas.add(creatingRect);
          canvas.setActiveObject(creatingRect);
        }

        let rect = creatingRect;
        if (rect) {
          if (opt.e.shiftKey) {
            rect.set("width", Math.min(w, h)).set("height", Math.min(w, h));
          } else {
            rect.set("width", w).set("height", h);
          }
          rect.setControlsVisibility({ mtr: false });
        }
        canvas.renderAll();
      }
    });
    canvas.on("mouse:up", function (opt) {
      const evt = opt.e;
      this.setViewportTransform(this.viewportTransform);
      this.isDragging = false;
      this.selection = true;
      this.isCreating = false;
      creatingRect = null;
      if (evt.button === 2) {
        if (started) {
          started = false;
        }
        // Remove if the rect is too small
        var objects = canvas.getObjects();
        objects.forEach((rect) => {
          if (
            rect &&
            (Math.abs(rect?.width) < 20 || Math.abs(rect.height) < 20)
          ) {
            // canvas.remove(rect);
            // Instead of deleting the crops, adding message to the crops that the crop size is less than threshold
            rect.set("crop_message", true)

            // setCanvas(canvas);
          }
        });
        canvas.requestRenderAll();

        // Disable all objects unselectable
        canvas.discardActiveObject();
        objects = canvas.getObjects();
        //Create the adblocks list

        let newCanvasObjects = objects.map((object, index) => {
          return {
            index: index,
            uuid: object?.id,
            blockType: object?.blockType,
            rejected: object?.rejected,
            approved: object?.approved,
            group_text: object?.group_text,
            group_type: object?.group_type,offer_text: object?.offer_text,
            offer_type: object?.offer_type,
            incentive_text: object?.incentive_text,
            incentive_type: object?.incentive_type,
            event_type: object?.event_type,
            event_text: object?.event_text,
            limited_time: object?.limited_time,
            start: object?.start,
            end: object?.end,
            reject_message: object?.reject_message,
            crop_message: object?.crop_message,
            loyalty_f : object?.loyalty_f,
            show_math_f : object?.show_math_f,
            online_only_f : object?.online_only_f
          };
        })

        newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
        setCanvasObjects(newCanvasObjects);
      }
    });

    //
    canvas.on("selection:created", function (opt) {
      if (opt.selected){
        setCurrentCanvasObjects(opt.selected.length > 0 ? opt.selected : [])
      }
      setCurrentAdblockId(opt.selected[0].id);
      setActiveCanvasObject(opt.selected[0]);
      // if (canvas.status === "move") {
      //   opt.target.hoverCursor = "move";
      // }
    });

    canvas.on("selection:updated", function (opt) {
      if (opt.selected){
        setCurrentCanvasObjects(opt.selected.length > 0 ? opt.selected : [])
      }
      // if (opt.selected[0].canvas) {
      //   if (opt.selected[0].canvas._objects?.length > 0){
      //     setCurrentCanvasObjects(opt.selected[0].canvas._objects)
      //   }
      // }
      setCurrentAdblockId(opt.selected[0].id);
      setActiveCanvasObject(opt.selected[0]);
      // if (canvas.status === "move") {
      //   opt.target.hoverCursor = "move";
      // }
    });

    canvas.on("selection:cleared", function (opt) {
      setCurrentCanvasObjects([]);
      setActiveCanvasObject(null);
    });
  };

  /*
  ///////////////////////////////////////
  ////// Watchers //////////////////
  /////////////////////////////////////
  */

  useEffect(() => {
    setIsLoading(false);
    setCurrentPage("TD - Adblocks");
    setPreviousTime(new Date());

    const canvi = new fabric.Canvas("canvas", {
      height: blockRef.current.offsetHeight,
      width: blockRef.current.offsetWidth,
      fireRightClick: true, // <-- enable firing of right click events
      stopContextMenu: true, // <--  prevent context menu from showing
    });

    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = "white";
    fabric.Object.prototype.cornerStrokeColor = currentOutlineColor;
    fabric.Object.prototype.cornerStyle = "circle";
    fabric.Object.prototype.cornerSize = 8;
    setCanvas(canvi);
    initHistory();
    init(blockType, canvi);
    fetchPageData(canvi);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (canvas) {
      init(blockType, canvas);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockType, digitalCouponApplied]);

  // useEffect(() => {
  //   if (canvasObjects.length > 0) {
  //     setIsRejected(false);

  //     if(canvasObjects.filter((currentItem) => currentItem.rejected === true).length > 0) {
  //       setIsRejected(true);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [canvasObjects]);

  

  // useEffect(() => {
  //   if (canvasObjects) {

  //     canvasObjects.sort(sortAdblocks)
  //     setCanvasObjects(canvasObjects);

  //   }
  //   return () => {};
  // }, [canvasObjects]);

  /*
  ///////////////////////////////////////
  ////// Fetch Data //////////////////
  /////////////////////////////////////
  */

  const handlePageData = async (canvas, result) => {
      if (result.payload !== "") {

        var tmpAdblocks;

        if (result.payload.sections && result.payload.groups) {
          tmpAdblocks = [
            ...result.payload.groups.map((group) => ({
              ...group,
              blockType: "group",
            })),
            ...result.payload.sections.map((section) => ({
              ...section,
              blockType: "section",
            })),
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        } else if (result.payload.groups) {
          tmpAdblocks = [
            ...result.payload.groups.map((group) => ({
              ...group,
              blockType: "group",
            })),
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        } else if (result.payload.sections) {
          tmpAdblocks = [
            ...result.payload.sections.map((section) => ({
              ...section,
              blockType: "section",
            })),
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        } else {
          tmpAdblocks = [
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        }

        tmpAdblocks = customSort({ data: tmpAdblocks, sortBy, sortField: 'blockType' });
        setAdBlockData(tmpAdblocks);
        fetchImage(
          pageData.filename,
          pageData.uuid,
          pageData.is_doubletruck,
          tmpAdblocks,
          currentCircularId,
          canvas
        );
        postPageEvents("ready", "");
      } else {
        //TODO: Show error message, system bugs?
      }
      postPageEvents("ready", "");
      setIsFetching(false);
    
  }

  const fetchPageData = async (canvas) => {
    setIsFetching(true);
    setNoQueue(false);
    let result = await getNextPageCrop();
    if (result.success) {
      if (result.payload !== "") {
        setCurrentPageId(result.payload.page.uuid);
        setCurrentCircularId(result.payload.circular.uuid);
        setActiveRetailer({
          retailer_name: result.payload.circular?.retailer?.name || "",
          circ_type: result.payload.circular?.circ_type
        });

        const page_type = PAGE_TYPES.find((item) => item.page_c === result.payload.page.page_loc);
        setpageType(page_type.page_nm);

        pushHistory({
          circularId: result.payload.circular.uuid,
          pageId: result.payload.page.uuid,
        });
        setQueueCount(result.payload.queue_count);

        var tmpAdblocks;

       if(result.payload.sections && result.payload.groups) {
        tmpAdblocks = [
          ...result.payload.groups.map((group) => ({
            ...group,
            blockType: "group",
          })),
          ...result.payload.sections.map((section) => ({
            ...section,
            blockType: "section",
          })),
          ...result.payload.adblocks.map((adblock) => ({
            ...adblock,
            blockType: "adblock",
          })),
        ];
       }else if(result.payload.groups) {
          tmpAdblocks = [
            ...result.payload.groups.map((group) => ({
              ...group,
              blockType: "group",
            })),
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        }else if(result.payload.sections) {
          tmpAdblocks = [
            ...result.payload.sections.map((section) => ({
              ...section,
              blockType: "section",
            })),
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        }else{
          tmpAdblocks = [
            ...result.payload.adblocks.map((adblock) => ({
              ...adblock,
              blockType: "adblock",
            })),
          ];
        }

        tmpAdblocks = customSort({data:tmpAdblocks, sortBy, sortField: 'blockType'});
        setAdBlockData(tmpAdblocks);
        if (result.payload.is_doubletruck){
          setIsDoubleTruck(true);
        } else {
          setIsDoubleTruck(false);
        }
        setMessageID(result.payload.message_id);
        setSessionId(result.payload.message_id);
        setCircularName(
          result.payload.circular.retailer.name +
            "_" +
            format(new Date(result.payload.circular.circ_week_dt.replace(/-/g, '/').replace(/T.+/, '')), "MM/dd/yyyy")
            + `_${result.payload.circular.ext_id}`
            + `_${result.payload.circular.circ_version ? result.payload.circular.circ_version : 0}`
        );


        if (result.payload.page && result.payload.page.filename) {
          setCanvasErrorMessage('');
          setPageData(result.payload.page);

          let filename = result.payload.page.filename;
          if(result.payload.page.is_doubletruck) {
            filename = result.payload.page.doubletruck_filename;
          }

          fetchImage(
            filename,
            result.payload.page.uuid,
            result.payload.page.is_doubletruck,
            tmpAdblocks,
            result.payload.circular.uuid,
            canvas
          );
        } else {
          canvas.clear();
          setCanvasErrorMessage('This page needs to be redownloaded!');
        }


      } else {
        setNoQueue(true);
        setQueueCount(0);
      }
      postPageEvents("ready", "");
    } else {
      //TODO: Show error message, system bugs?
    }
    postPageEvents("ready", "");
    setIsFetching(false);
  };
  
  const fetchImage = async (id, pageId, doubletruck, adblocks, circularId, canvas) => {
    setIsFetching(true);

    // Check if the image is cached
    const cachedImage = await getCachedImage(id);
    if (cachedImage) {
      applyImage(cachedImage, pageId, doubletruck, adblocks, circularId, canvas);
      return;
    }

    // Fetch the image from the API
    const img = await getImage(id);
    if (img.success) {
      // Cache the fetched image
      await setCachedImage(id, img.payload);
      applyImage(img.payload, pageId, doubletruck, adblocks, circularId, canvas);
    } else {
      setIsFetching(false);
      //TODO: If image doesnt load show and error
    }
  };

  const applyImage = async (base64Image, pageId, doubletruck, adblocks, circularId, canvas) => {
    let tempIncentives = [];
    const pageData = await getPageById(pageId);
    if (pageData?.success) {
      if (pageData.payload?.incentive_nm) {
        tempIncentives = [
          ...splitIncentives(pageData.payload?.incentive_nm).map((item) => ({
            text: item,
            type: "page",
          })),
        ];
      }
      if (pageData.payload.crop_approved || pageData.payload.is_dupe || pageData.payload.autocrop_finished_at != null || pageData.payload.notes=="Could not get crops from adcrop") {
        setIsApproveDisabled(false);
      }
      else if (pageData.payload.autocrop_finished_at == null && adblocks.some(block => block.uuid != null)) {
        setIsApproveDisabled(false);
      }
      else {
        toast.error("Page is not autocropped yet.", {
          position: "top-left", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
          pauseOnHover: true, progress: undefined, theme: "light"
        });
        setIsApproveDisabled(true);
      }
      setDigitalCouponApplied(Boolean(pageData.payload?.digital_coupon_f))

      if(pageData.payload.dupe_of) {
        const parent_page = await getPageByObjId(pageData.payload.dupe_of);
        if(parent_page.success) {
          console.log('parent_page', parent_page.payload);
          setparentPageData(parent_page.payload);
          if (parent_page.payload.crop_approved) {
            setIsApproveDisabled(false);
          } else {
            setIsApproveDisabled(true);
          }
  
          const parent_page_circular = await getCircularByObjID(parent_page.payload.circular_id);
          if(parent_page_circular.success) {
            setparentPageCircularData(parent_page_circular.payload);
          }else{
            //Error 
          }       
  
        }else{
          //Error 
        }
      }

    }

    const circularData = await getCircularById(circularId);
    if (circularData?.success && circularData.payload?.incentive_nm) {
      tempIncentives = [
        ...tempIncentives,
        ...splitIncentives(circularData.payload?.incentive_nm).map((item) => ({
          text: item,
          type: "circular",
        })),
      ];
    }

    setIncentiveData(tempIncentives);

    if (canvas) {
      canvas.clear();
      canvas.zoomToPoint({ x: 0, y: 0 }, 1);
      let vpt = canvas.viewportTransform;
      vpt[4] = 0;
      vpt[5] = 0;

      var background = new Image();
      background.onload = async function () {
        setIsFetching(true);

        var f_img = new fabric.Image(background);

        setCanvasRatio(canvas.height / background.height);
        // canvas.setBackgroundImage(f_img, canvas.renderAll.bind(canvas), {
        //   scaleX: canvas.height / background.height,
        //   scaleY: canvas.height / background.height,
        // });
        f_img.set({
          scaleX: canvas.height / background.height,
          scaleY: canvas.height / background.height,
        });
        canvas.backgroundImage = f_img;
        canvas.renderAll();

        adblocks = customSort({data:adblocks, sortBy, sortField: 'blockType'});
        let blocks = adblocks;
        blocks.forEach((block) => {
          let height = Math.abs(block.coords_y2 - block.coords_y1) * (canvas.height / background.height);
          let width = Math.abs(block.coords_x2 - block.coords_x1) * (canvas.height / background.height);
          if (Math.abs(width) < 20 || Math.abs(height) < 20) {
            block.crop_message = true;
          }
        });
        setAdBlockData(blocks);
        drawAdblocks(canvas.height / background.height, blocks, canvas);

        if(doubletruck) {
          var line = new fabric.Line([(background.width/2)/4,0,(background.width/2)/4,canvas.height], {
            stroke: 'green'
          });
  
          canvas.add(line);
          canvas.renderAll();
          setCanvas(canvas);
        }

        //Create the adblocks list
        var objects = canvas.getObjects();
        let canvasObjects = objects.map((object, index) => {
          return {
            index: index,
            uuid: object?.id,
            blockType: object?.blockType,
            text: object?.text,
            rejected: object?.rejected,
            approved: object?.approved,
            group_text: object?.group_text,
            group_type: object?.group_type,offer_text: object?.offer_text,
            offer_type: object?.offer_type,
            incentive_text: object?.incentive_text,
            incentive_type: object?.incentive_type,
            event_type: object?.event_type,
            event_text: object?.event_text,
            limited_time: object?.limited_time,
            start: object?.start,
            end: object?.end,
            reject_message: object?.reject_message,
            crop_message: object?.crop_message,
            loyalty_f : object?.loyalty_f,
            show_math_f : object?.show_math_f,
            online_only_f : object?.online_only_f
          };
        });
        canvasObjects = customSort({data:canvasObjects, sortBy, sortField: 'blockType'});
        setCanvasObjects(canvasObjects);
        setIsFetching(false);
      };

      background.src = "data:image/png;base64," + base64Image;
      canvas.renderAll();
      setCanvas(canvas);
    } else {
      //TODO: If image doesnt load show and error
    }
    setIsFetching(false);
  };

  const navigateNext = async () => {
    setIsDoubleTruck(false)
    canvas && canvas.clear();
    setAdBlockData([]);
    setCanvasObjects([]);
    fetchPageData(canvas);
  };

  const handleLinkCopy = () => {
    const el = document.createElement("input");
    el.value =
      location.origin + "/adblock/" + currentCircularId + "/" + currentPageId;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopiedText(true);
    setTimeout(() => {
      setCopiedText(false);
    }, 2500);
  };

  const drawAdblocks = (canvasRatio, adBlockData, canvas) => {
    // Draw block rect data if available
    if((blockType === "adblock" && showAdBlocks)
      || (blockType === "section" && showSections)  
      || (blockType === "group" && showGroups)) {
        if (adBlockData.length > 0) {
          adBlockData.forEach((adblock) => {

            var fill_color = (fillActive ? "rgba(128,128,128, .35)" : "transparent");
            var stroke_color = currentOutlineColor;
            //if status is reject or approve display something diffrent
            if (adblock.rejected) {
              fill_color = "rgba(255,132,132,0.35)";
              stroke_color = "#FF8484";
            } else if (adblock.approved) {
              fill_color = "rgba(99,206,107,0.25)";
              stroke_color = "#63CE6B";
            }

        const rect = new fabric.Rect({
          left: adblock.coords_x1 * canvasRatio,
          top: adblock.coords_y1 * canvasRatio,
          height: (adblock.coords_y2 - adblock.coords_y1) * canvasRatio,
          width: (adblock.coords_x2 - adblock.coords_x1) * canvasRatio,
          stroke: currentOutlineColor,
          strokeWidth: 1,
          fill: fill_color,
          ornerStrokeColor: stroke_color,
          cornerColor: "white",
          id: adblock.uuid,
          blockType: adblock.blockType,
          rejected: adblock.rejected,
          approved: adblock.approved,
          group_text: adblock.blockType === "group" ? adblock?.group_text || "" : "",
          group_type: adblock.blockType === "group" ? adblock?.group_type || "" : "",offer_text: adblock.blockType === "group" ? adblock?.offer_text || null : "",
          offer_type: adblock.blockType === "group" ? adblock?.offer_type || null : "",
          incentive_text: adblock.blockType === "group" ? adblock?.incentive_text || null : "",
          incentive_type: adblock.blockType === "group" ? adblock?.incentive_type || null : "",
          event_type: adblock.blockType === "group" ? adblock?.event_type || null : "",
          event_text: adblock.blockType === "group" ? adblock?.event_text || null : "",
          limited_time: adblock.blockType === "group" ? adblock?.limited_time || null : "",
          start: adblock.blockType === "group" ? adblock?.start || null : "",
          end: adblock.blockType === "group" ? adblock?.end || null : "",
          reject_message: adblock.reject_message,
          crop_message: adblock.hasOwnProperty('crop_message') ? adblock?.crop_message : false,
          loyalty_f: adblock.blockType === "group" ? adblock?.loyalty_f || null : "",
          show_math_f : adblock.blockType === "group" ? adblock?.show_math_f || null : "",
          online_only_f : adblock.blockType === "group" ? adblock?.online_only_f || null : "",
        });
        rect.setControlsVisibility({ mtr: false });
        canvas.add(rect);
      });
      canvas.renderAll();
      setCanvas(canvas);
    }
      }
  };

  /*
  ///////////////////////////////////////
  ////// Page Flags //////////////////
  /////////////////////////////////////
  */

  const handleReject = async () => {
    setIsSubmitting(true);
    let data = {};
    data.message_id = messageID;
    try {
      await rejectPage(currentPageId, data);
      navigateNext();
    } catch (error) {
      setErrorText(error.toString());
      alertModal.openModal();
    }
    setIsSubmitting(false);
  };

  const handleApprove = async () => {
    setIsSubmitting(true);
    const crops = canvas.getObjects();
    let data = {};
    const adblocks = crops
      .filter((crop) => crop.blockType === "adblock")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }

        return {
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          uuid: uuid,
          rejected: false
        };
      });
    const sections = crops
      .filter((crop) => crop.blockType === "section")
      .map((crop) => {
        var uuid;

        if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
          uuid = null;
        } else {
          uuid = crop?.id;
        }
        let event_nm = "";
        const sec = canvasObjects.find((item) => item.uuid === crop.id);
        if (sec) {
          event_nm = sec.text;
        }
        return {
          coords_x1:
            Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_x2:
            Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
          coords_y1:
            Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          coords_y2:
            Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
          uuid: uuid,
          event_nm,
        };
      });

      const groups = crops
        .filter((crop) => crop.blockType === "group")
        .map((crop) => {
          var uuid;

          if (crop?.id.indexOf("temp") !== -1 || crop?.id === undefined) {
            uuid = null;
          } else {
            uuid = crop?.id;
          }


          // let group_text = "";
          // let group_type = "";

          // const group = canvasObjects.find((item) => item.uuid === crop.id);
          // if (group) {
          //   group_type = group.group_type;
          //   if (group_type === 'event'){
          //     group_text = group.group_text.join();
          //   } else {
          //     group_text = group.group_text;
          //   }
          // }

          return {
            coords_x1:
              Math.min(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
            coords_x2:
              Math.max(crop.aCoords.tl.x, crop.aCoords.br.x) / canvasRatio,
            coords_y1:
              Math.min(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
            coords_y2:
              Math.max(crop.aCoords.tl.y, crop.aCoords.br.y) / canvasRatio,
            uuid: uuid,
            offer_type: crop.offer_type,
            offer_text: crop.offer_text,
            event_type: crop.event_type,
            event_text: crop.event_text ? Array.isArray(crop.event_text) ? crop.event_text.join() : crop.event_text : '',
            incentive_type: crop.incentive_type,
            incentive_text: crop.incentive_text,
            limited_time: crop.limited_time,
            start: crop.start ? crop.start : null,
            end: crop.end ? crop.end : null,
            loyalty_f : crop.loyalty_f,
            show_math_f : crop.show_math_f,
            online_only_f : crop.online_only_f
          };
        });


    data.adblocks = adblocks;
    data.message_id = messageID;
    data.sections = sections;
    data.groups = groups;
    data.is_doubletruck = isDoubleTruck;
    data.digital_coupon_f = digitalCouponApplied;

    if (incentiveData.filter(({ type }) => type === "page").length > 0) {
      
      await savePageIncentiveString(
        currentPageId,
        incentiveData
          .filter(({ type }) => type === "page")
          .map((item) => item.text)
          .join(",")
      );
    }else{
      await savePageIncentiveString(
        currentPageId,
        null
      );
    }
    if (incentiveData.filter(({ type }) => type === "circular").length > 0) {
      await saveCircularIncentiveString(
        currentCircularId,
        incentiveData
          .filter(({ type }) => type === "circular")
          .map((item) => item.text)
          .join(",")
      );
    }else{
      await saveCircularIncentiveString(
        currentCircularId,
        null
      );
    }

    try {
      await approvePage(currentPageId, data);
      const res = await getCurrentUserAPI();
      if (res.success) {
        setLiveCounterData(res.results);
        setDigitalCouponApplied(false);
      }
      navigateNext();
    } catch (error) {
      setErrorText(error.toString());
      alertModal.openModal();
    }
    setIsSubmitting(false);
  };

  /*
  ///////////////////////////////////////
  ////// Auto Crop //////////////////
  /////////////////////////////////////
  */

  const handleAutoCrop = async (force = false) => {
    setIsAdCropping(true);
    const result = await postPageAutoCrop(currentPageId, force);
    if (result.success) {
      fetchImage(pageData.filename, currentPageId, false, result.payload.adblocks, currentCircularId, canvas);
    } else {
      //TODO: set auto crop fail here
    }
    setIsAdCropping(false);
    postPageEvents("click", "auto crop");
  };

  /*
  ///////////////////////////////////////
  ////// Canvas Tools //////////////////
  /////////////////////////////////////
  */

  const handleCanvisObjectMouseOver = (canvi, event) => {
    if (event?.target && canvi.status !== "crop") {
      if (event.target === canvi.getActiveObject()) {
        event.target.hoverCursor = "move";
      }
      event.target.set("strokeDashArray", [5]);
      canvi.renderAll();
    }
  };

  /*
  ///////////////////////////////////////
  ////// Adblock Methods  //////////////////
  /////////////////////////////////////
  */

  const handleUnsetDoubletruck = async () => {
    setIsSubmitting(true);
    try {
      const result = await unsetDoubletruckPage(currentPageId);
      if(result.success) {
        //Reload page
        window.location.reload();
        //navigateNext();
    
      }else{
      // Log error message
      }
      
    } catch (error) {
        // Error
    }
    setIsSubmitting(false);
  };

  const handleDoubletruck = async () => {
    setIsSubmitting(true);
    try {
      const result = await createDoubletruckPage(currentPageId);
      if(result.success && result.payload.errors === "") {

        fetchImage(result.payload.message, currentPageId, true, adBlockData, currentCircularId, canvas);
        pageData.is_doubletruck = true;
        // Set the page object as double truck

        setIsDoubleTruck(true);
    
      }else{
        setErrorText(result.payload.errors);
        alertModal.openModal();
      }
      
    } catch (error) {
      
    }
    setIsSubmitting(false);
  };

  const handleDoubletruckVertical = async () => {
    setIsSubmitting(true);
    try {
      const result = await createDoubletruckPageVerical(currentPageId);
      if(result.success && result.payload.errors === "") {

        fetchImage(result.payload.message, currentPageId, true, adBlockData, currentCircularId, canvas);
        pageData.is_doubletruck = true;
        // Set the page object as double truck

        setIsDoubleTruck(true);
    
      }else{
        setErrorText(result.payload.errors);
        alertModal.openModal();
      }
      
    } catch (error) {
      
    }
    setIsSubmitting(false);
  };


  function deleteFromList(selected) {

    //Find the object in the list, create new list
    var objects = canvas.getObjects();
    let newCanvasObjects = objects
    .filter((item) => item.id !== selected.uuid)
    .map((object, index) => {
      return {
        index: index,
        uuid: object?.id,
        blockType: object?.blockType,
        text: object?.text,
        rejected: object?.rejected,
        approved: object?.approved,
        group_type: object?.group_type,
        group_text: object?.group_text,
        reject_message: object?.reject_message,
        crop_message: object?.crop_message
      };
    });

    const seletedIndex = objects.findIndex(
      (item) => item.id === selected.uuid
    );

    //select the object first
    canvas.setActiveObject(canvas.item(seletedIndex));
    setCurrentAdblockId("");

    // //delete the object
    canvas.remove(canvas.item(seletedIndex));

    //Update the new list after deletion
    canvas.requestRenderAll();
    newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
    //newCanvasObjects.sort(sortAdblocks)
    setCanvasObjects(newCanvasObjects);
  }
  
  async function handleListDelete(selected) {
    setIsDeleting(true);
    if(selected.blockType === "adblock") {

      if(selected.uuid.includes('temp')) {
        deleteFromList(selected);
      }else{
        const result = await deleteAdBlockById(selected.uuid);
        if (result.success) {
          
          deleteFromList(selected);
  
        } else {
          //TODO: failed to delete adblock
        }
      }

    }else if(selected.blockType === "section"){

      if(selected.uuid.includes('temp')) {
        deleteFromList(selected);
      }else{

        const result = await deleteSectionById(selected.uuid);
        if (result.success) {
          
          deleteFromList(selected);

        } else {
          //TODO: failed to delete adblock
        }
      }

    }else{

      if(selected.uuid.includes('temp')) {
        deleteFromList(selected);
      }else{
        // const result = await deleteSectionById(activeCanvasObject.id);
        // if (result.success) {
          
        //   removeItemFromSingle(activeCanvasObject);

        // } else {
        //   //TODO: failed to delete adblock
        // }
      }

    }
    setIsDeleting(false);
  }

  function removeItemFromSingle(activeCanvasObject) {
    
      //Find the object in the list, create new list
      var objects = canvas.getObjects();
      let newCanvasObjects = objects.filter(
        (item) => item.id !== activeCanvasObject.id
      );

      newCanvasObjects = newCanvasObjects.map((object, index) => {
        return {
          index: index,
          uuid: object?.id,
          blockType: object?.blockType,
          text: object?.text,
          rejected: object?.rejected,
          approved: object?.approved,
          group_type: object?.group_type,
          group_text: object?.group_text,
          reject_message: object?.reject_message,
          crop_message: object?.crop_message
        };
      });

      // //delete the object
      canvas.remove(activeCanvasObject);
      canvas.requestRenderAll();

      newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
      //Update the new list after deletion
      //newCanvasObjects.sort(sortAdblocks)
      setCanvasObjects(newCanvasObjects);
  }
  function handleDeleteBlock() {
    setIsDeleting(true);
    if (currentCanvasObjects.length > 0) {
      handleMultiDelete();
    } else {
      handleSingleDelete(activeCanvasObject);
    }
    setIsDeleting(false);
  }

  async function handleSingleDelete(obj) {

    if(obj.blockType === "adblock") {

      if(obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      }else{
        const result = await deleteAdBlockById(obj.id);
        if (result.success) {
          
          removeItemFromSingle(obj);

        } else {
          //TODO: failed to delete adblock
        }
      }

    }else if(obj.blockType === "section"){

      if(obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      }else{
        const result = await deleteSectionById(obj.id);
        if (result.success) {
          
          removeItemFromSingle(obj);

        } else {
          //TODO: failed to delete adblock
        }
      }

    }else{

      if(obj.id?.includes('temp')) {
        removeItemFromSingle(obj);
      }else{
        // const result = await deleteSectionById(activeCanvasObject.id);
        // if (result.success) {
          
        //   removeItemFromSingle(activeCanvasObject);

        // } else {
        //   //TODO: failed to delete adblock
        // }
      }

    }

  }

  async function handleMultiDelete() {
    setIsDeleting(true);
    currentCanvasObjects?.map(async obj => {
      await handleSingleDelete(obj)
    });
    setIsDeleting(false);
    
    setCurrentCanvasObjects([]);
    canvas.discardActiveObject();
    canvas.renderAll(); 
  }


  const handleAdblockSelect = (uuid, index) => {
    if (index < canvas.getObjects().length) {
      setCurrentAdblockId(uuid);
      canvas.setActiveObject(canvas.item(index));
      canvas.requestRenderAll();
    }
  };

  const handlePickColor = (color) => {
    postPageEvents("click", "Color");
    setCurrentOutlineColor(color);
    canvas.getObjects().map(function (o) {
      return o.set({
        stroke: color,
        cornerStrokeColor: color,
      });
    });
    canvas.requestRenderAll();
  };

  const handleFillSelect = () => {
    canvas.getObjects().map(function (o) {
      return o.set({
        fill: !fillActive ? "rgba(128,128,128, .35)" : "transparent"
      });
    });
    
    setFillActive(!fillActive);
    canvas.requestRenderAll();
  };

  const handleClickAutoCrop = () => {
    if (adBlockData.length > 0) {
      retryCroppingModal.openModal();
    } else {
      handleAutoCrop(false);
    }
  };

  const handleClickAdblockType = () => {
    setBlockType("adblock");
  };

  const handleClickSectionType = () => {
    setBlockType("section");
  };
  const handleClickGroupType = () => {
    setBlockType("group");
  };
  const handleClickAdblockShow = () => {
    canvas.getObjects()
    .filter((crop) => crop.blockType === "adblock")
    .map(function (o) {
      return o.set({
        opacity: !showAdBlocks ? 1 : 0,
      });
    });
    
    setShowAdBlocks(!showAdBlocks);
    canvas.requestRenderAll();
  };

  const handleClickSectionShow = () => {
    canvas.getObjects()
    .filter((crop) => crop.blockType === "section")
    .map(function (o) {
      return o.set({
        opacity: !showSections ? 1 : 0,
      });
    });
    
    setShowSections(!showSections);
    canvas.requestRenderAll();
  };

  const handleClickGroupShow = () => {
    canvas.getObjects()
    .filter((crop) => crop.blockType === "group")
    .map(function (o) {
      return o.set({
        opacity: !showGroups ? 1 : 0,
      });
    });
    
    setShowGroups(!showGroups);
    canvas.requestRenderAll();
  };


  const handleChangeText = (id, group_text) => {

    var objects = canvas.getObjects();
    let newCanvasObjects = objects.map((object, index) => {
      let data = {
        index: index,
        blockType: object?.blockType,
        uuid: object?.id,
        rejected: object?.rejected,
        approved: object?.approved,
        group_type: object?.group_type,
        group_text: object?.group_text,
        reject_message: object?.reject_message,
        crop_message: object?.crop_message
      };
      if(object?.blockType === 'group' &&  object.id === id) {
        data = {
          ...group_text,
          ...data
        }
        object.set("offer_text", group_text.offer_text);
        object.set("offer_type", group_text.offer_type);
        object.set("incentive_text", group_text.incentive_text);
        object.set("incentive_type", group_text.incentive_type);
        object.set("event_type", group_text.event_type);
        object.set("event_text", group_text.event_text);
        object.set("limited_time", group_text.limited_time);
        object.set("start", group_text.start);
        object.set("end", group_text.end);
        object.set("loyalty_f", group_text.loyalty_f);
        object.set("show_math_f", group_text.show_math_f);
        object.set("online_only_f", group_text.online_only_f);
      }

      return data;
    })

    newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
    //newCanvasObjects.sort(sortAdblocks);
    setCanvasObjects(newCanvasObjects);


  };

  async function handleDeleteDupes() {
    handleOpenModal(true);
  }

  async function fetchAdblockCrops() {
    let results = await getPageCrops(currentPageId);
    if (results.success) {
      setIsFetching(true);
      setNoQueue(false);
      canvas && canvas.clear();
      handlePageData(canvas, results)
    }
    else {
    }
  }

  async function deleteDupes() {
    setIsSubmitting(true);
    const result = await deleteDuplicatePageAdBlocks(currentPageId);
    if (result.success) {
      await fetchAdblockCrops();
    } else {
      // Error
    }
    setIsSubmitting(false);
  }

  const handleOpenModal = () => {
    setConfirmationMessage("Are you sure you want to delete duplicate adblocks from page?");
    setConfirmationModalOpen(true);
  };

  const handleCancelConfirmation = () => {
    setConfirmationModalOpen(false);
  };

  const handleContinue = async () => {
    setConfirmationModalOpen(false);
    await deleteDupes();
  };
  
const handleChangeSelect = (id, group_type) => {
    var objects = canvas.getObjects();
    let newCanvasObjects = objects.map((object, index) => {
      let data = {
        index: index,
        blockType: object?.blockType,
        uuid: object?.id,
        rejected: object?.rejected,
        approved: object?.approved,
        group_type: object?.group_type,
        group_text: object?.group_text,
        reject_message: object?.reject_message,
        crop_message: object?.crop_message
      };

      if(object?.blockType === 'group' &&  object.id === id) {
        data.group_text =  object?.group_text;
        data.group_type = group_type;
        object.set('group_type', group_type);
      }

      return data;
    })


    newCanvasObjects = customSort({data:newCanvasObjects, sortBy, sortField: 'blockType'});
    //newCanvasObjects.sort(sortAdblocks);
    setCanvasObjects(newCanvasObjects);

  };


  /*
  ///////////////////////////////////////
  ////// Keyboard events  //////////////////
  /////////////////////////////////////
  */

  useKeypress(["Escape"], (event) => {
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    setCurrentAdblockId("");
  });

  useKeypress(["Delete"], (event) => {
    if (currentAdBlockId) {
      handleListDelete({ uuid: currentAdBlockId }, selectedIndex);
    }
  });

  return (
    <SkeletonTheme color="#202020" highlightColor="#444">
      <MainLayout>
        <Header>
          {isLoading ? (
            <div className="d-flex">
              <div className="my-auto">
                <Skeleton height={24} width={800} />
              </div>
            </div>
          ) : (
            <div className="d-flex row w-100">
              <div className="my-auto d-flex">
                {/* <BreadCrumb className="ml-3 my-auto">{circularName}</BreadCrumb> */}
                <Link href={`/circular/${currentCircularId}/${currentPageId}`} 
                  className="ml-2 my-auto" >
                  {circularName}
                </Link>
                <BreadCrumb className="ml-3 my-auto">
                  {currentPageId}
                </BreadCrumb>
                <PageType className="ml-2 my-auto">
                    {pageType}
                  </PageType>
                <HistoryDropdown className="ml-4" width={320} type="adblock" />
                {currentPageId ? (
                  <Button
                    buttonTheme="dark"
                    size="small"
                    width="120px"
                    className="ml-2 my-auto"
                    onClick={handleLinkCopy}
                  >
                    {!copiedText ? "COPY LINK" : "COPIED!"}
                  </Button>
                ) : null}
              </div>
              <PageInfo className="ml-auto my-auto ">{`Remaining in queue:  ${queueCount}`}</PageInfo>

              {/* {userInfo.user?.is_superuser ? */}
                <Button
                  buttonTheme="dark"
                  width="100px"
                  size="small"
                  className="ml-3 my-auto"
                  onClick={() => rejectPageModal.openModal()}
                  isLoading={isSubmitting}
                  disabled={isFetching || isLoading || isNoQueue}
                  eventType="flag"
                >
                  REJECT
                </Button>
              {/* : null } */}

              {pageData.is_doubletruck ?
                <Button
                  buttonTheme={"dark"}
                  width="160px"
                  size="small"
                  className="ml-2 my-auto"
                  onClick={handleUnsetDoubletruck}
                  isLoading={isSubmitting}
                  eventType="flag"
                  disabled={isFetching || isLoading}
                >
                  Unset Doubletruck
                </Button> 
                : <DropDownMenu
                title="DoubleTruck"
                isLoading={isSubmitting}
                disabled={isFetching || isLoading}
              >
                  <MenuItem
                    buttonTheme={"dark"}
                    width="150px"
                    size="small"
                    onClick={() => handleDoubletruck()}
                    disabled={isFetching || isLoading}
                  >
                    Horizontal <VscSplitHorizontal />
                  </MenuItem>
                  <MenuItem
                    buttonTheme={"dark"}
                    width="150px"
                    size="small"
                    onClick={() => handleDoubletruckVertical()}
                    disabled={isFetching || isLoading}
                  >

                    Vertical <VscSplitVertical />
                  </MenuItem>
                </DropDownMenu>
                }

              <Button
                buttonTheme="dark"
                width="120px"
                size="small"
                className="ml-2 my-auto"
                onClick={() => {
                  if (canvasObjects.length > 0){
                    handleApprove()
                  } else {
                    approvePageWithNoAdblockModal.openModal()
                  }
                }}
                isLoading={isSubmitting}
                disabled={isFetching || isLoading || isNoQueue || isApproveDisabled }
                eventType="flag"
              >
                APPROVE
              </Button>
            </div>
          )}
        </Header>

        <Content>
          <ToolContent>
            CREATE:
            <AdblockToolButton
              onClick={handleClickAdblockType}
              type="Adblock"
              isActive={blockType === "adblock"}
            />
            <AdblockToolButton
              onClick={handleClickGroupType}
              type="Group"
              isActive={blockType === "group"}
            />
            <AdblockToolButton
              onClick={handleClickSectionType}
              type="Section"
              isActive={blockType === "section"}
            />
            <br/>
            SHOW:
            <AdblockToolButton
              onClick={handleClickAdblockShow}
              type="Adblock"
              isActive={showAdBlocks}
            />
            <AdblockToolButton
              onClick={handleClickGroupShow}
              type="Group"
              isActive={showGroups}
            />
            <AdblockToolButton
              onClick={handleClickSectionShow}
              type="Section"
              isActive={showSections}
            />
          </ToolContent>
          <div className="d-flex flex-1">
            <SelectionContainer>
              <SelectionHeader>
                PAGE ADBLOCK CROPPING
                {isDoubleTruck ? 
                  <Status info>
                    Double Truck
                  </Status>
                : null}
                {pageData.is_dupe
                  ? (
                    <>
                      <Status>VARIANT</Status>

                      {parentPageData.crop_approved && !pageData.crop_approved ?
                        <Status info>Queued for Processing</Status>
                        : null}

                      <Link className={'link'} target="_blank" href={location.origin + "/adblock/" + parentPageCircularData?.uuid + "/" + parentPageData?.uuid}>View Parent</Link>

                    </>
                  )
                  : null}
                <div className="ml-auto d-flex">
                  {isFetching || isLoading
                    ? null : (
                      <Button width="170px" buttonTheme="error"
                        size="small"
                        className="link" onClick={handleDeleteDupes}>Delete Duplicates</Button>
                    )}
                  <FillSelect 
                    active={fillActive}
                    onClick={() => handleFillSelect()}/>
                  {OUTLINE_COLORS.map((color) => {
                    return (
                      <ColorPick
                        bgColor={color}
                        key={color}
                        active={color === currentOutlineColor}
                        onClick={() => handlePickColor(color)}
                      />
                    );
                  })}
                  {!isAdCropping ? (
                    <MdRefresh
                      className="refresh ml-2 my-auto"
                      size={18}
                      onClick={handleClickAutoCrop}
                    />
                  ) : null}
                  {activeCanvasObject ? (
                    !isDeleting ?
                      <FaTrash
                        className="delete ml-2 my-auto mr-2"
                        onClick={handleDeleteBlock}
                      /> :
                      <FaHourglass
                        className="delete ml-2 my-auto mr-2"
                      />
                  ) : null}
                </div>
              </SelectionHeader>

              {isAdCropping || isFetching || isSubmitting || isNoQueue ? (
                <CanvasOverlay>
                  {isAdCropping ? ( //TODO: we can rotate text and make it look like it is processing
                    <AutoCropping height={canvas.height} width={canvas.width}>
                      Recropping adblocks for this page, please do not refresh
                      or close the page. This process can take a minute to 90
                      seconds.
                    </AutoCropping>
                  ) : null}

                  {isFetching || isSubmitting ? (
                    <SkeletonContainer>
                      <Skeleton height={canvas.height} width={canvas.width} />
                    </SkeletonContainer>
                  ) : null}

                  {isNoQueue ? (
                    <NoQueue>No more Pages in queue.</NoQueue>
                  ) : null}
                </CanvasOverlay>
              ) : null}

              <CanvasContainer className="w-100" ref={blockRef}>
                <div>
                  {canvasErrorMessage ?
                    <div className="pt-4 mt-4 mx-auto text-center color-white">
                      {canvasErrorMessage}
                    </div> : ''}
                </div>
                <Canvas id="canvas" />
              </CanvasContainer>
            </SelectionContainer>
          </div>
          <RightSection>
            <DigitalCouponCheck 
              value={digitalCouponApplied}
              onChange={(e) => {
                setDigitalCouponApplied(e)
              }}
            />
            <AdblockIncentives
              onAdd={handleAddIncentive}
              onDelete={handleRemoveIncentive}
              onUpdate={handleUpdateIncentive}
              data={incentiveData}
            />
            <AdblocksContainer>
              <SelectionHeader>
                {canvasObjects.length} <span>({ canvasObjects.filter((currentItem) => currentItem.rejected === true).length})</span> ADBLOCKS
              </SelectionHeader>
              <SelectionContent>
                {isLoading || isSubmitting || isFetching ? (
                  <Skeleton count={10} height={40} style={{ marginTop: 8 }} />
                ) : (
                  <>
                    {canvasObjects.map((item, index) =>
                      item.blockType === "adblock" ? (
                        <AdblockItem
                          data={item}
                          key={index}
                          onDelete={handleListDelete}
                          index={index}
                          active={item.uuid === currentAdblockId}
                          onClick={() => handleAdblockSelect(item.uuid, index)}
                          isDeleting={isDeleting}
                        />
                      ) : item.blockType === "section" ? (
                        <SectionItem
                          data={item}
                          key={index}
                          onDelete={handleListDelete}
                          index={index}
                          active={item.uuid === currentAdblockId}
                          onClick={() => handleSectionSelect(item.uuid, index)}
                          onChangeText={(e) => handleChangeText(item.uuid, e)}
                          isDeleting={isDeleting}
                        />
                      ) : item.blockType === "group" ? (
                        <GroupItem
                          data={item}
                          key={index}
                          index={index}
                          active={item.uuid === currentAdblockId}
                          onClick={() => handleSectionSelect(item.uuid, index)}
                          onChangeText={(e) => handleChangeText(item.uuid, e)}
                          onChangeSelect={(e) => handleChangeSelect(item.uuid, e)}
                          onDelete={(e) => handleListDelete(item)}
                          isDeleting={isDeleting}
                        />
                      ) : null
                    )}
                  </>
                )}
              </SelectionContent>
            </AdblocksContainer>
          </RightSection>
        </Content>
        <Alert {...alertModal} title="Error" size="small">
          {errorText}
        </Alert>
        <RetryCroppingModal
          onOk={() => handleAutoCrop(true)}
          {...retryCroppingModal}
        />
        <RejectPageWarning
          {...rejectPageModal}
          onReject={() => handleReject()}
        />
        <ApprovePageNoAdblockWarning
          {...approvePageWithNoAdblockModal}
          onApprove={() => handleApprove()}
        />
        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          msgBody={confirmationMessage}
          onContinue={handleContinue}
          onCancel={handleCancelConfirmation}
        ></ConfirmationModal>
      </MainLayout>
      <ToastContainer />
    </SkeletonTheme>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
`;

const Header = styled.div`
  height: 48px;
  color: white;
  font-size: 20px;
  display: flex;
  padding: 0 24px;
  background: ${(props) => props.theme.palette.backgrounds};
  margin-bottom: 1px;
`;

const ToolContent = styled.div`
  width: 64px;
  color: white;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.palette.backgrounds};
  margin: 2px 2px;
  padding: 8px 0;
`;

const SelectionContainer = styled.div`
  min-width: 320px;
  margin: 2px 2px;
  background: ${(props) => props.theme.palette.backgrounds};
  padding: 12px 8px;
  flex: 1;
  position: relative;
`;

const AdblocksContainer = styled.div`
  min-width: 320px;
  margin: 2px 2px;
  background: ${(props) => props.theme.palette.backgrounds};
  padding: 12px 8px;
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

const SkeletonContainer = styled.div`
  margin-top: -4px;
`;

const SelectionHeader = styled.div`
  text-transform: uppercase;
  color: white;
  font-size: ${(props) => props.theme.font.size.m};
  border-bottom: 1px solid ${(props) => props.theme.palette.secondary};
  position: relative;
  margin-bottom: 5px;
  display: flex;
  svg {
    color: white;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
  .link {
    margin:0 10px;
  }
`;

const SelectionContent = styled.div`
  text-transform: uppercase;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 14px;
    background: ${(props) => props.theme.palette.backgrounds};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.palette.backgrounds};
    border: 1px solid ${(props) => props.theme.palette.itemsHover};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.palette.itemsHover};
    cursor: pointer;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    cursor: pointer;
  }
`;

const CanvasContainer = styled.div`
  height: calc(100% - 30px) !important;
  background-color: ${(props) => props.theme.palette.items};
`;

const CanvasOverlay = styled.div`
  height: calc(100% - 30px) !important;
  position: absolute;
  z-index: 1;
`;

const AutoCropping = styled.div`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  background-color: ${(props) => props.theme.palette.items};
  padding: 20px;
  color: ${(props) => props.theme.palette.white};
`;

const NoQueue = styled.div`
  color: white;
  padding: 20px;
`;

const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
`;

const PageInfo = styled.div`
  font-size: 16px;
  color: white;
`;

const PageType = styled.div`
  padding: 5px;
  font-size: 14px;
`;

const BreadCrumb = styled.div`
  color: white;
  font-size: 14px;
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const Status = styled.div`
  margin: 0px 0 4px 10px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 12px;
  height: 22px;
  padding: 5px 8px;
  background: ${(props) =>
    props.approved
      ? props.theme.palette.success
      : props.rejected
      ? props.theme.palette.error
      : props.warning
      ? props.theme.palette.warning
      : props.info
      ? props.theme.palette.info:
      props.theme.palette.warning};
  color: ${(props) =>
    props.approved || props.rejected
      ? props.theme.palette.white
      : props.theme.palette.background};
`;

const MenuItem = styled(Button)`
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`



